export default __webpack_public_path__ + "static/media/5w30.fde433f4.png";